import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {CreateData, getalltagsdata} from '../../Tags/TagSlice/TagsSlices'

const AddFieldModel = ({show, handleClose}: any) => {
  const dispatch = useDispatch()
  const [fieldName, setFieldName] = useState('')
  const [error, setError] = useState('')

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-550px'
        className='vh-100'
        show={show}
        onHide={() => {
          handleClose('')
          setFieldName('')
        }}
      >
        <>
          <div className='modal-header'>
            <h1>Create new field</h1>
          </div>
          <div className='modal-body'>
            <label className='w-100'>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Field name
              </span>
              <input
                onBlur={() => {
                  ;/^[a-zA-Z0-9_ -]{2,25}$/.test(fieldName)
                    ? setError('')
                    : setError('please enter valid field name')
                }}
                placeholder='Field name'
                maxLength={25}
                className='form-control form-control-solid border-0 w-100 mt-2'
                onChange={(e: any) => {
                  setError('')
                  setFieldName(e.target.value)
                }}
              />
              <span className='text-danger mt-1'>{error}</span>
              <span
                style={{
                  color: '#a1a5b7',
                  fontSize: '12px',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                Field name must consist of; Alphanumeric characters and underscores. Max length 25
                characters with no spaces.
              </span>
            </label>
          </div>
          <div className='modal-footer w-100'>
            <button
              onClick={() => {
                handleClose('')
                setFieldName('')
              }}
              type='button'
              className='btn btn-light-primary'
            >
              Cancel
            </button>
            <button
              disabled={error !== '' || fieldName == ''}
              onClick={() => {
                handleClose(fieldName)
                setFieldName('')
              }}
              id='submit'
              type='button'
              className='btn btn-primary w-50 '
            >
              Create field
            </button>
          </div>
        </>
      </Modal>
    </>
  )
}

export default AddFieldModel
